"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO use getEnvVar function here.
exports.axiosConfigValues = {
    timeoutPeriod: process.env.REACT_APP_TIMEOUT_PERIOD ? parseInt(process.env.REACT_APP_TIMEOUT_PERIOD, 10) : 0,
    // axios config
    sessionCookieName: process.env.REACT_APP_SESSION_COOKIE_NAME || '',
    sessionDomain: process.env.REACT_APP_SESSION_DOMAIN || '',
    // value for lifetime is in seconds
    sessionLifetime: process.env.REACT_APP_SESSION_LIFETIME || '',
    sessionRequestHeaderName: process.env.REACT_APP_SESSION_HEADER || '',
    sessionResponseHeaderName: process.env.REACT_APP_SESSION_HEADER || '',
    // value is in milliseconds
    cacheMaxAge: process.env.REACT_APP_AXIOS_CACHE_MAX_AGE ? parseInt(process.env.REACT_APP_AXIOS_CACHE_MAX_AGE, 10) : 0,
};
//# sourceMappingURL=axiosConfigValues.js.map